var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fu-drai",attrs:{"data-test":"fu-drawer-ai-form"}},[_c('fu-icon',{attrs:{"name":"bot","size":16}}),_c('span',[_vm._v("Teamio’s AI assistant calls "+_vm._s(_vm.firstName || 'the patient')+" from your practice number and logs the outcome here. This is a simulation — no real call is placed.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }